import { render } from "./RecursiveDependentQuestions.vue?vue&type=template&id=a4cc747e"
import script from "./RecursiveDependentQuestions.vue?vue&type=script&lang=js"
export * from "./RecursiveDependentQuestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__